import cx from 'classnames';

import { ICON_MAPPING, STATUS_CONFIG, StatusText } from "../constant";

import styles from './styles.module.scss';
import { useGetTranslatedText } from '../../lms/queries';
import { getTranslatedText } from '../../../../utils/getTranslatedText';

const StatusBanner = (props) => {
    const {status} = props;

    const config = STATUS_CONFIG[status];

    const className = styles[StatusText[status]];

    const languageId = localStorage.getItem("l_id") || 1;
      
    const { data: translatedTextResponse } = useGetTranslatedText(languageId);
      
    const { data: translatedText = [] } = translatedTextResponse || {};

    
    const title = getTranslatedText(
    translatedText,
    config.titleKey,
    config?.title,
  );

  const description = getTranslatedText(
    translatedText,
    config.des_key,
    config?.description
  );

  return (
    <div className={cx(styles.container,className)}>
      <div className={styles.icon}>
        <img src={ICON_MAPPING[status]} alt=''/>
      </div>
      <div>
        <p className={cx(styles.title)}>{title}</p>
        <p className={cx(styles.description)}>{description}</p>
      </div>
    </div>
  );
};

export default StatusBanner;